// Utility to clean markdown from excerpts and descriptions
// Removes hashtags, asterisks, and other markdown formatting

export const cleanExcerpt = (text) => {
    if (!text || typeof text !== 'string') {
        return text;
    }
    
    let cleaned = text;
    
    // Remove hashtag headings (# ## ### ####)
    cleaned = cleaned.replace(/^#{1,4}\s+/gm, '');
    
    // Remove bold formatting (**text** -> text)
    cleaned = cleaned.replace(/\*\*([^*]+)\*\*/g, '$1');
    
    // Remove italic formatting (*text* -> text)
    cleaned = cleaned.replace(/\*([^*]+)\*/g, '$1');
    
    // Remove code blocks (```code``` -> code)
    cleaned = cleaned.replace(/```[\s\S]*?```/g, '');
    
    // Remove inline code (`code` -> code)
    cleaned = cleaned.replace(/`([^`]+)`/g, '$1');
    
    // Remove bullet points (- item -> item)
    cleaned = cleaned.replace(/^- /gm, '');
    
    // Clean up extra whitespace
    cleaned = cleaned.replace(/\s+/g, ' ').trim();
    
    return cleaned;
};

export default cleanExcerpt;